"use strict";

exports.__esModule = true;
exports.default = sortAscending;
function sortAscending(list) {
    return list.sort(function (a, b) {
        return a - b;
    });
};
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/postcss-selector-parser/dist/sortAscending.js
// module id = 3481
// module chunks = 0